var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1141 5.13333C17.3294 4.26625 16.8969 3.1527 16.8973 2H13.3501V15.7778C13.3227 16.5234 12.9975 17.2296 12.4429 17.7477C11.8883 18.2658 11.1477 18.5555 10.3769 18.5556C8.74676 18.5556 7.39217 17.2667 7.39217 15.6667C7.39217 13.7556 9.29778 12.3222 11.2608 12.9111V9.4C7.30033 8.88889 3.8335 11.8667 3.8335 15.6667C3.8335 19.3667 7.00186 22 10.3654 22C13.97 22 16.8973 19.1667 16.8973 15.6667V8.67778C18.3357 9.67761 20.0626 10.2141 21.8335 10.2111V6.77778C21.8335 6.77778 19.6753 6.87778 18.1141 5.13333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIcon);
export default __webpack_public_path__ + "static/media/tiktok-icon.17a66baefd0fbefdb21427d8947651ff.svg";
export { ForwardRef as ReactComponent };